/** @flow */

import React from "react";
import classNames from "classnames";
import "./icons.style.scss";

type Props = $Exact<{
  color?: string,
  className?: string,
  onClick?: (event: SyntheticEvent<HTMLButtonElement>) => void,
}>;

const DeskIcon = (props: Props) => (
  <svg
    className={classNames("icons", props.color, props.className, {
      charcoal: !props.color,
    })}
    viewBox="0 0 24 24"
    onClick={props.onClick}
    xmlns="http://www.w3.org/2000/svg"
  >
    <g>
      <rect x="0.5" y="4.5" width="15" height="4" />
      <polyline points="0.5 19.5 0.5 4.5 16 4.5" />
      <rect x="15.5" y="4.5" width="8" height="6" />
      <rect x="15.5" y="10.5" width="8" height="9" />
      <path d="M19.5,8 C19.224,8 19,8.225 19,8.5 C19,8.778 19.224,9 19.5,9 C19.776,9 20,8.778 20,8.5 C20,8.225 19.776,8 19.5,8 Z" />
      <path d="M19.5,14 C19.224,14 19,14.225 19,14.5 C19,14.778 19.224,15 19.5,15 C19.776,15 20,14.778 20,14.5 C20,14.225 19.776,14 19.5,14 Z" />
      <path d="M23.5,6.5 L15.5,6.5" />
      <path d="M23.5,12.5 L15.5,12.5" />
    </g>
  </svg>
);

export default DeskIcon;
